<template>
  <div class="footer">
    <div class="row justify-content-between align-items-center">
      <div class="col">
        <p class="fs-6 mb-0">© Wu Fitness. <span class="d-none d-sm-inline-block">2023.</span></p>
      </div>
      <div class="col-auto">
        <div class="d-flex justify-content-end">
          <ul class="list-inline list-separator">
            <li class="list-inline-item">
              <a class="list-separator-link" href="#">FAQ</a>
            </li>

            <li class="list-inline-item">
              <a class="list-separator-link" href="#">License</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'footer-view'
}
</script>